/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

import sliceConstants from './loyaltySchemeSettingsPageSliceConstants';
import extraActions from './loyaltySchemeSettingsPageSliceExtraActions';
import extraReducers from './loyaltySchemeSettingsPageSliceExtraReducers';
import standardReducers from './loyaltySchemeSettingsPageSliceStandardReducers';

const slice = createSlice({
	name: sliceConstants.name,
	initialState: sliceConstants.initialState,
	// Standard reducer logic. (For each of these reducers action types get auto-generated)
	reducers: {
		...standardReducers,
	},
	// Additional reducers for additional custom action types. (Ex. createAsyncThunk Actions)
	extraReducers: {
		...extraReducers,
	},
});

const { name, actions: standardActions, reducer } = slice;

const actions = {
	...standardActions,
	...extraActions,
};

export { name, actions, reducer, slice };

export default reducer;
